import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const receivedPdfFile = createAsyncThunk(
  "receivedpdf/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetDocumentPathReceived/${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ReceivedPDFSlice = createSlice({
  name: "receivedPDF",
  initialState: {
    ReceivedPdfDta: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(receivedPdfFile.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(receivedPdfFile.fulfilled, (state, action) => {
        state.ReceivedPdfDta = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(receivedPdfFile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});

export default ReceivedPDFSlice.reducer;

